export default "__VITE_ASSET__uSje6yB9__"